// extracted by mini-css-extract-plugin
export default {"controlButton":"CAErYx","hidden":"qipy26","loader":"HFEl1G","rotate":"bNfw61","active":"KRw0M5","clip":"i0S9__","clip-reverse":"m1Fg4V","clipReverse":"m1Fg4V"};